let blocks = document.querySelectorAll('[data-three-tips-box]');
let descriptionBlocks = document.querySelectorAll('[data-three-tips-description]');
let maxHeight = 0;
descriptionBlocks.forEach(descriptionBlock => {
    if (maxHeight < descriptionBlock.offsetHeight) {
        maxHeight = descriptionBlock.offsetHeight;
    }
})
let totalHeight = (maxHeight + 230) + 'px';

blocks.forEach(block => {
    block.addEventListener('click', function handleClick(event) {
        event.preventDefault();
        let button = block.querySelector('[data-three-tips-button]');
        let ifAccordionOpen = button.getAttribute('aria-expanded');
        if (ifAccordionOpen == 'false') {
            let container = button.previousElementSibling;
            container.style.height = totalHeight;
            button.setAttribute('aria-expanded', 'true');
            block.classList.add('open');
        }
        else {
            let container = button.previousElementSibling;
            container.style.height = '0px';
            button.setAttribute('aria-expanded', 'false');
            block.classList.remove('open');
        }
    });
});